import { useEffect } from 'react';

/**
 * Stops mouse-wheel / trackpad from changing focused number inputs.
 * Blurs the field so the scroll continues on the page/sidebar instead.
 * Register once at the app root.
 */
const useScrollBlockForNumberInput = () => {
  useEffect(() => {
    const onWheel = () => {
      const active = document.activeElement;
      if (active instanceof HTMLInputElement && active.type === 'number') {
        active.blur();
      }
    };

    document.addEventListener('wheel', onWheel, { passive: true });
    return () => document.removeEventListener('wheel', onWheel);
  }, []);
};

export default useScrollBlockForNumberInput;
